import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentCategory } from 'app/models/dto/document-category.model';

@Component({
  selector: 'app-add-document-button',
  templateUrl: './add-document-button.component.html',
  styleUrls: ['./add-document-button.component.scss'],
  standalone: false
})
export class AddDocumentButtonComponent implements OnInit {

  @Input() documentCategories: DocumentCategory[];
  @Output() addDocument = new EventEmitter<DocumentCategory>();

  constructor() { }

  ngOnInit(): void {}

  addCategory(documentCategory: DocumentCategory) {
    this.addDocument.emit(documentCategory);
  }
}
